import Modal from "./Modal";

import useBrowser from "../../hooks/useBrowser";

import ProjectLocationEditor from "../editors/ProjectLocationEditor";

const ProjectLocationModal = ({ projectId, locationId, open, onClose }) => {
  const { windowHeight, windowWidth } = useBrowser();

  return (
    <Modal
      title="Project Location"
      open={open}
      onClose={onClose}
      width={`${windowWidth}px`}
      height={`${windowHeight}px`}
    >
      <ProjectLocationEditor
        projectId={projectId}
        locationId={locationId}
      />
    </Modal>
  );
};

export default ProjectLocationModal;
